module.exports = "<span>{{ $ctrl.organization.name }}</span> ";